import React                       from 'react';
import { useSelector }             from "react-redux";
import DoExportContainer           from "../../../containers/DoExportContainer";
import ExportListContainer         from "../../../containers/ExportListContainer";
import { ApplicationState }        from "../../../store";
import { APIState }                from "../../../store/API/types";
import { LayoutState }             from "../../../store/layouts/types";
import ExportAviFileUIComponent    from "../ExportAviFileUIComponent";
import ExportListUIComponent       from "../ExportListUIComponent";
import ExportTimePickerUIComponent from "../ExportTimePickerUIComponent";

const ExportUIComponent = () => {
  const {serviceType} = useSelector<ApplicationState, APIState>(state => state.API)
  const {exportStatusListOpened} = useSelector<ApplicationState, LayoutState>(state => state.layouts);

  return (
    <div className='flex export-block'>
      <ExportTimePickerUIComponent/>
      <div>
        <DoExportContainer/>
        <ExportAviFileUIComponent/>
      </div>
      <div>
        {
          serviceType !== 2 && <>
            {exportStatusListOpened && <ExportListContainer/>}
            <ExportListUIComponent/>
          </>
        }
      </div>
    </div>
  )
};

export default ExportUIComponent